import {
  BaseFormViewModel,
} from '../../types';
import {
  DeliveryRegionDTO,
} from './deliveryRegionDTO';

export class DeliveryRegionFormViewModel extends BaseFormViewModel<DeliveryRegionDTO> {
  regionId: number;

  isActive: boolean;

  regionName?: string;

  daysTillDelivery: number;

  deliveryFees?: number;

  constructor(dto: DeliveryRegionDTO) {
    super();
    const newFormModel = {
      regionId: dto.regionId,
      isActive: dto.isActive,
      regionName: dto.regionName ?? '',
      daysTillDelivery: dto.daysTillDelivery,
      deliveryFees: dto.deliveryFees ?? '',
    };
    Object.assign(this, newFormModel);
  }

  toDTO() {
    return {
    } as DeliveryRegionDTO;
  }
}
